import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { Util } from '../../helpers/global.util';

@Component({
    selector: 'change-pwd-dialog',
    templateUrl: './change-pwd-dialog.html',
})
export class ChangePwdDialogComponent {
    @ViewChild('dlg') dlg: DialogComponent;
    pwd: string = null;
    pwdConfirm: string = null;
    visible: boolean = false;

    constructor(private http: HttpService, private helper: HelperService) {
    }

    show() {
        this.reset();
        this.dlg.show();
    }

    reset() {
        this.pwd = null;
        this.pwdConfirm = null;
    }

    isInputValid() {
        if (Util.isFieldEmpty(this.pwd)) {
            this.helper.alertFailed('Password is require.');
            return false;
        }

        if (Util.isFieldEmpty(this.pwdConfirm)) {
            this.helper.alertFailed('Password Confirm is require.');
            return false;
        }

        if (this.pwd !== this.pwdConfirm) {
            this.helper.alertFailed('Password and password confirm are not the same.');
            return false;
        }

        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i;
        if (!reg.test(this.pwd)) {
            this.helper.alertFailed('Mật khẩu phải có ít nhất 8 ký tự, có chữ, số và ký tự đặc biệt/ Minimum eight characters, at least one letter, one number and one special character.');
            return false;
        }

        return true;
    }

    onOK() {
        if (this.isInputValid()) {
            this.dlg.hide();
            this.http.post(`api/Authen/ChangePwd/${this.pwd}`, null, res => {
                this.helper.alert('Change password success');
            });
        }
    }

    onCancel() {
        this.dlg.hide();
    }
}
